var React = require('react');

function ClickAndCollectInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","stroke":"#1D1D1B","strokeLinejoin":"round","strokeWidth":"2","d":"M10.9785156,20 L11.9785156,12 L3.97851562,14 L5.97851562,16 L3,19.7231968 L5.57142857,21.9731968 L8.97851562,18 L10.9785156,20 Z M10.5927447,10.0150218 L10.9785156,5 L20.9785156,5 L21.9785156,18 L13.9785156,18 M13.9785156,8 L13.9785156,4 C13.9785156,2.79503573 14.7362028,2 15.9785156,2 C17.2215805,2 17.9785156,2.79503573 17.9785156,4 L17.9785156,8"}));
}

ClickAndCollectInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = ClickAndCollectInline;

ClickAndCollectInline.default = ClickAndCollectInline;
